import Vue from "vue";
import { Ability } from "@casl/ability";
import DefaultAbility from "./default";

Vue.prototype.$ability = new Ability([]);

function updateAbility(user) {
  if (!user) return;
  const abilities = [...DefaultAbility];

  // Handle the menu access from JWT token
  if (user.accessRole && Array.isArray(user.accessRole)) {
    user.accessRole.forEach(accessRole => {
      // Split the ActionList by comma and process each action
      if (accessRole.ActionList) {
        let roleList = accessRole.ActionList.split(",");
        roleList.forEach(role => {
          abilities.push({
            action: role.trim().toLowerCase(),
            subject: accessRole.AccessRoleCode.toLowerCase(),
          });
        });
      }
    });
  }
  Vue.prototype.$ability.update(abilities);
}

function removeAbility() {
  Vue.prototype.$ability.update([]);
}

export default Vue.prototype.$ability;

export { updateAbility, removeAbility };
